
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Punetoshirdicabbooking() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Cab Booking',
        heading: 'Mauli Cabs:  Pune to Shirdi Cab Booking ',
        headingDescription: 'Mauli Cabs makes your Pune to Shirdi cab booking easy, convenient, and affordable. Whether you are planning a spiritual trip to Shirdi or a family outing, we offer a variety of vehicles including sedans, SUVs, and premium cabs to suit your needs. Travel comfortably with professional drivers, transparent pricing, no hidden charges, and a commitment to providing a smooth and safe journey from Pune to Shirdi.',

        top: 'Top Places to Visit in Shirdi with Mauli Cabs',

"topPlaces": [
    {
        "title": "Sai Baba Temple",
        "description": "The main attraction of Shirdi, the Sai Baba Temple is a sacred pilgrimage site dedicated to Sri Sai Baba. Devotees from all over the world visit to seek blessings and experience the serene spiritual atmosphere."
    },
    {
        "title": "Dwarkamai",
        "description": "Dwarkamai is a mosque where Sai Baba spent a significant part of his life. It holds immense religious significance and houses sacred objects associated with the saint, offering visitors a glimpse into his simple life."
    },
    {
        "title": "Chavadi",
        "description": "Located near the Sai Baba Temple, Chavadi is where Sai Baba used to rest during his later years. It is an important pilgrimage spot and plays a vital role in the Thursday Palkhi procession."
    },
    {
        "title": "Sai Heritage Village",
        "description": "This is a unique theme park that depicts the life and times of Sai Baba through beautiful statues and scenes. It's a great place for families to learn about Sai Baba's life in an interactive way."
    },
    {
        "title": "Wet n Joy Water Park",
        "description": "Located close to the main temple, Wet n Joy Water Park is a fun spot for families and children. It features thrilling rides, wave pools, and a relaxed environment to cool off after temple visits."
    },
    {
        "title": "Shri Sai Baba Sansthan Museum",
        "description": "The museum showcases various items used by Sai Baba, including his utensils, clothes, and photographs. It provides a deep insight into the saint's life and teachings."
    },
    {
        "title": "Khandoba Temple",
        "description": "This is one of the oldest temples in Shirdi and holds historical significance, as it is where Sai Baba was first recognized as a holy figure by the local priest Mhalsapati."
    },
    {
        "title": "Lendi Baug",
        "description": "A peaceful garden developed by Sai Baba himself, Lendi Baug is a serene place for meditation and reflection. It contains a well and a lamp lit by Sai Baba, which continues to burn to this day."
    },
    {
        "title": "Upasani Maharaj Ashram",
        "description": "Located a short distance from the main temple complex, this ashram was established by Upasani Maharaj, a devoted disciple of Sai Baba. It’s a quiet place for spiritual seekers."
    },
    {
        "title": "Maruti Mandir",
        "description": "One of the oldest temples in Shirdi, Maruti Mandir is dedicated to Lord Hanuman. It is believed that Sai Baba often visited this temple, making it a spiritually significant site for devotees."
    }
],

"services": [
    {
        "name": "Pune to Shirdi Cab Service",
        "description": "Mauli Cabs offers reliable and affordable cab services from Pune to Shirdi. Whether you're traveling for pilgrimage or leisure, we ensure a safe and comfortable journey."
    },
    {
        "name": "Book Pune to Shirdi Taxi",
        "description": "Book your taxi from Pune to Shirdi with Mauli Cabs. Our fleet includes a range of vehicles, ensuring a smooth and hassle-free ride for your pilgrimage or trip."
    },
    {
        "name": "Pune to Shirdi One-Way Cab",
        "description": "Looking for a one-way cab service from Pune to Shirdi? Mauli Cabs offers convenient and affordable one-way rides to ensure a comfortable and timely journey."
    },
    {
        "name": "Pune to Shirdi Round Trip",
        "description": "Planning a round trip from Pune to Shirdi? Mauli Cabs offers round-trip cab services with flexible schedules, making your travel convenient and stress-free."
    },
    {
        "name": "Affordable Pune to Shirdi Cab",
        "description": "Mauli Cabs offers affordable taxi services from Pune to Shirdi without compromising comfort. Enjoy a cost-effective yet reliable journey."
    },
    {
        "name": "Private Taxi for Shirdi from Pune",
        "description": "Travel in privacy and comfort with a private taxi from Pune to Shirdi. Mauli Cabs ensures a personalized and safe ride for your pilgrimage or trip."
    },
    {
        "name": "Luxury Cab from Pune to Shirdi",
        "description": "For those who prefer a luxurious ride, Mauli Cabs offers premium cab services from Pune to Shirdi. Enjoy a first-class journey with spacious and well-maintained vehicles."
    },
    {
        "name": "Shirdi Pilgrimage Cab Service from Pune",
        "description": "Mauli Cabs offers dedicated pilgrimage cab services for travelers going from Pune to Shirdi. We ensure a comfortable and peaceful journey to this sacred destination."
    },
    {
        "name": "Pune to Shirdi Temple Trip by Taxi",
        "description": "Plan your temple trip to Shirdi from Pune with Mauli Cabs. Our taxis are well-maintained, and our drivers are experienced, ensuring a safe and pleasant experience for your spiritual journey."
    },
    {
        "name": "Comfortable Taxi from Pune to Shirdi",
        "description": "Mauli Cabs provides comfortable and reliable taxis for your journey from Pune to Shirdi. Our vehicles are clean, spacious, and ready to offer a smooth ride."
    },
    {
        "name": "Group Travel to Shirdi from Pune",
        "description": "Traveling with a group? Mauli Cabs offers spacious vehicles that can comfortably accommodate your group for the journey from Pune to Shirdi. Enjoy a comfortable, stress-free trip together."
    }
],

"tableData": [
    ["Pune to Shirdi Cab Service", "Book Pune to Shirdi Taxi"],
    ["Pune to Shirdi One-Way Cab", "Pune to Shirdi Round Trip"],
    ["Affordable Pune to Shirdi Cab", "Private Taxi for Shirdi from Pune"],
    ["Luxury Cab from Pune to Shirdi", "Shirdi Pilgrimage Cab Service from Pune"],
    ["Pune to Shirdi Temple Trip by Taxi", "Comfortable Taxi from Pune to Shirdi"],
    ["Group Travel to Shirdi from Pune", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "At Mauli Cabs, we prioritize punctuality for your Pune to Shirdi Cab Booking. Whether you're traveling for pilgrimage or leisure, our drivers ensure on-time pickups and drop-offs, helping you reach Shirdi safely and on schedule."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a range of vehicles to make your journey to Shirdi as comfortable as possible. From sedans to SUVs and premium cars, our fleet is designed with air conditioning, ample legroom, and spacious interiors for a relaxing ride."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our skilled and professional drivers are familiar with the Pune to Shirdi route, ensuring a smooth, safe, and timely journey. With knowledge of the best routes and traffic conditions, they ensure you have a hassle-free experience."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs provides competitive pricing for your Pune to Shirdi Cab Booking, with no hidden charges. We offer clear and transparent pricing so that you can travel without worrying about unexpected fees."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly serviced and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols, ensuring a secure and comfortable trip to Shirdi."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Whether it's an early morning departure or a late-night return, Mauli Cabs is available 24/7 for your Pune to Shirdi Cab Booking. Our customer service team is always ready to assist you at any time of the day."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking your Pune to Shirdi cab with Mauli Cabs is simple and quick. You can reserve your ride online through our website or mobile app, or you can call our customer service team for personalized assistance with your booking."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Whether you're traveling for a religious trip, family vacation, or solo journey, Mauli Cabs offers customized travel packages for your Pune to Shirdi Cab Booking. Share your preferences, and we’ll create a travel plan tailored to your needs."
    }
]




    }



    const faqData = [
        {
            question: 'How do I book a cab from Pune to Shirdi with Mauli Cabs?',
            answer: 'Booking your cab is easy! You can book directly through our website or mobile app. Just enter Pune as your pickup location and Shirdi as your destination, then choose the vehicle that fits your needs. Alternatively, you can call our support team for assistance.',
        },
        {
            question: 'What types of cabs are available for Pune to Shirdi?',
            answer: 'Mauli Cabs offers a variety of vehicles, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Choose the one that fits your comfort and space requirements.',
        },
        {
            question: 'Is the fare from Pune to Shirdi fixed?',
            answer: 'Yes, the fare is fixed and transparent. It includes tolls, taxes, and driver charges. No hidden costs—you’ll know the total fare upfront.',
        },
        {
            question: 'Can I book a round trip from Pune to Shirdi?',
            answer: 'Yes, you can easily book both one-way and round-trip rides. Just provide your return details when making the booking, and we’ll take care of the rest.',
        },
        {
            question: 'How long does the journey from Pune to Shirdi take?',
            answer: 'The ride from Pune to Shirdi typically takes around 4.5 to 5 hours, depending on traffic conditions. We aim to provide a smooth and timely journey.',
        },
        {
            question: 'Are your drivers experienced with the Pune to Shirdi route?',
            answer: 'Yes, our drivers are highly experienced, well-trained, and familiar with the best routes to ensure a safe and comfortable ride.',
        },
        {
            question: 'Can I book a cab for a religious tour to Shirdi?',
            answer: 'Yes, Mauli Cabs offers comfortable and reliable cabs for your religious tour to Shirdi. We ensure that you have a peaceful and pleasant journey to the holy town.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained?',
            answer: 'Absolutely! All our cabs are fully air-conditioned and well-maintained for comfort and cleanliness. We prioritize hygiene for a pleasant ride.',
        },
        {
            question: 'Can I cancel or modify my booking after confirmation?',
            answer: 'Yes, you can cancel or modify your booking. Our flexible cancellation policy is available through the website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Shirdi trip?',
            answer: 'Mauli Cabs offers competitive prices, a range of vehicle options, professional drivers, and reliable service. Whether for a religious visit or leisure, we ensure a comfortable and hassle-free ride.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Anil Sharma",
            position: "Devotee",
            text: "A peaceful and smooth journey from Pune to Shirdi with Mauli Cabs. The ride was comfortable, and the driver ensured we reached safely and on time. Highly recommend!",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Deshmukh",
            position: "Pilgrim",
            text: "It was an amazing experience. The cab was clean, the driver was courteous, and we reached Shirdi without any hassle. Very happy with Mauli Cabs service!",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Shirdi Cab Booking by Mauli Cabs",
        "description": "Mauli Cabs provides reliable Pune to Shirdi cab services with options for one-way or round-trip journeys. Choose from private and luxury taxis for a comfortable pilgrimage or group travel. Affordable fares and 24x7 online booking available.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "5400"
        }
      };
      
  
      

    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to Shirdi Cab Booking | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book Pune to Shirdi cab with Mauli Cabs. Comfortable and affordable one-way or round-trip taxi service for your Shirdi temple visit. Luxury and group cab options available with 24x7 booking support."
        />
        <meta
          name="keywords"
          content="Pune to Shirdi cab service, Book Pune to Shirdi taxi, Pune to Shirdi one-way cab, Pune to Shirdi round trip, Affordable Pune to Shirdi cab, Private taxi for Shirdi from Pune, Luxury cab from Pune to Shirdi, Shirdi pilgrimage cab service from Pune, Pune to Shirdi temple trip by taxi, Comfortable taxi from Pune to Shirdi, Group travel to Shirdi from Pune"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/2.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdicabbooking;